export default {
  borderColorDisabled: 'none',
  backgroundDisabled: 'var(--light-grey)',
  backgroundEnabled: 'var(--mpc)',
  backgroundEnabledValidatedPost: 'var(--cta-color)',
};
